import { TagHeap } from './TagHeap';

export { TagHeap };
export default TagHeap;
